import { AppConfig } from 'shared/utils/env'

export const VALID_SOURCES = [
    'app', // dev contacts created before source was corrected
    'csv',
    AppConfig.source,
    AppConfig.name
]
